import { QueryClient } from '@tanstack/react-query';

/**
 * Configuração global do React Query
 * 
 * ESTRATÉGIA DE CACHE:
 * - staleTime: 5min → Dados considerados "frescos" por 5 minutos
 * - cacheTime: 10min → Dados permanecem em cache por 10 minutos
 * - refetchOnWindowFocus: true → Revalida ao voltar pra aba
 * - retry: 1 → Tenta novamente uma vez em caso de erro
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Dados são considerados "fresh" por 5 minutos
      // Durante esse tempo, não faz novas requisições
      staleTime: 5 * 60 * 1000, // 5 minutos

      // Dados permanecem em cache por 10 minutos após ficarem inativos
      cacheTime: 10 * 60 * 1000, // 10 minutos (deprecated, usar gcTime no futuro)
      
      // Revalidar automaticamente quando usuário voltar pra aba
      refetchOnWindowFocus: true,

      // Revalidar quando reconectar à internet
      refetchOnReconnect: true,

      // Revalidar ao montar se os dados estiverem stale (antigos)
      // Se invalidamos a query (após mutation), ela vai refetch ao montar
      refetchOnMount: true,

      // Tentar novamente 1x em caso de erro
      retry: 1,

      // Delay entre retries (500ms)
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      // Tentar novamente 1x em caso de erro em mutations
      retry: 1,
    },
  },
});

/**
 * Cache keys para organização
 */
export const QUERY_KEYS = {
  // Artigos
  articles: 'articles',
  article: (id) => ['article', id],
  articlesByTag: (tagId) => ['articles', 'tag', tagId],
  articlesByCollection: (collectionId) => ['articles', 'collection', collectionId],
  
  // Tags
  tags: 'tags',
  tag: (id) => ['tag', id],
  
  // Coleções
  collections: 'collections',
  collection: (id) => ['collection', id],
  collectionArticles: (id) => ['collection', id, 'articles'],
  
  // Fontes
  sources: 'sources',
  
  // Facetas (filtros dinâmicos)
  facets: (filters) => ['facets', filters],
};

